import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import css from "./loader-bar.module.css";
export default function Bar({ className }) {
    const classes = classNames(className, css.inner);
    return (_jsx("div", { className: css.outer, role: "progressbar", children: _jsx("div", { className: classes, children: _jsx("div", { className: css.bar }) }) }));
}
